<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <i class="fas fa-shopping-basket"></i> Beli Lepas
                </div>
                <div class="card-tools mr-0">
                    <button class="btn btn-primary" @click="exportExcel()">
                        <i class="fa fa-file-excel"></i> Export Excel
                    </button>
                    <button :disabled="isLoading" type="button" class="btn btn-primary" @click="printList">
                        <i class="fas fa-print"></i> Print
                    </button>
                    <button v-if="$can('create beli lepas')" type="button" class="btn btn-primary" @click="addNew">
                        <i class="fas fa-plus-square"></i> Input Data
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-3">
                    <search-bar @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="/api/beli-lepas"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="action-slot" slot-scope="props">
                            <button type="button" title="View" @click="view(props.rowData)" class="btn btn-link px-1"><i class="fas fa-eye"></i></button>
                            <button type="button" title="Print" @click="print(props.rowData)" class="btn btn-link px-1"><i class="fas fa-print"></i></button>
                            <button v-if="($can('edit beli lepas') && isSameDay(props.rowData.created_at)) || isSuperAdmin" type="button" title="Edit" @click="edit(props.rowData)" class="btn btn-link px-1"><i class="fas fa-edit"></i></button>
                            <button v-if="($can('delete beli lepas') && isSameDay(props.rowData.created_at)) || isSuperAdmin" type="button" title="Delete" @click="deleteItem(props.rowData)" class="btn btn-link px-1 text-danger"><i class="fas fa-trash-alt"></i></button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal v-model="editModal" size="md" :hide-header="true" :hide-footer="true">
            <edit-form :isEdit="isEdit" :value="currentPembelian" @saved="saved" @cancel="editModal = false"></edit-form>
		</b-modal>
    </section>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import EditForm from './Form';
import SearchBar from './SearchBar';
import Viewer from './Viewer';
import ExportMixin from '../../mixin/export';

export default {
    name: "beli-lepas",

    components: {
        EditForm,
        SearchBar,
        Viewer,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            isEdit: false,
            isKoreksi: false,
            currentPembelian: null,
            searchText: '',
            searchDate: '',
            searchGudangId: '',
            searchGraderId: '',
            editModal: false,
            viewModal: false,
            exportUrl: '/export/beli-lepas',
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'code',
                    title: 'Kode',
                    sortField: 'id',
                },
                {
                    name: 'gudang.name',
                    title: 'Gudang',
                    sortField: 'gudang_name',
                },
                {
                    name: 'grader.name',
                    title: 'Nama Grader',
                    sortField: 'grader_name',
                },
                {
                    name: 'supplier.name',
                    title: 'Supplier',
                    sortField: 'supplier_name',
                },
                {
                    name: 'grade.name',
                    title: 'Grade',
                    sortField: 'grade_name',
                },
                {
                    name: 'created_at',
                    title: 'Tanggal',
                    sortField: 'created_at',
                    callback: 'formatDate',
                },
                {
                    name: 'created_at',
                    title: 'Waktu',
                    callback: 'formatDatetime|HH:mm',
                },
                {
                    name: 'bobot',
                    title: 'Berat (kg)',
                    sortField: 'bobot',
                    callback: 'formatNumber',
                },
                {
                    name: 'note',
                    title: 'Catatan',
                    sortField: 'note',
                    callback: 'formatValue',
                },
                {
                    name: '__slot:action-slot',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "updated_at", direction: "desc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                grader_id: this.searchGraderId,
                gudang_id: this.searchGudangId,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchGraderId = search.searchGraderId;
            this.searchGudangId = search.searchGudangId;
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.searchDate = '';
            this.searchGraderId = '';
            this.searchGudangId = '';
            this.refresh();
        },

        addNew() {
            this.isEdit = false;
            this.currentPembelian = null;
            this.editModal = true;
        },

        edit(rowData) {
            this.isEdit = true;
            this.currentPembelian = Object.assign({}, rowData);
            this.editModal = true;
        },

        view(rowData) {
            this.currentPembelian = Object.assign({}, rowData);
            this.isEdit = false;
            this.editModal = true;
        },

        saved(pembelian) {
            this.editModal = false;
            if (!this.isEdit || this.isKoreksi) {
                this.currentPembelian = Object.assign({}, pembelian);
                this.viewModal = true;
            }
            this.isEdit = false;
            this.isKoreksi = false;
            this.refresh();
        },

        deletePembelian(rowData) {
            let self = this;

            Swal.fire({
                title: 'Apakah anda yakin?',
                text: "Anda tidak dapat mengembalikan data yang sudah dihapus!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, hapus!'
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    self.$Progress.start();
                    axios({
                        method: 'delete',
                        url: '/api/users/' + rowData.id,
                    })
                    .then(function (response) {
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });
                        self.$Progress.finish();
                        self.refresh();
                    })
                    .catch(function (error) {
                        self.responseFailed(error);
                    });
                }
            })
        },

        printList(){
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            let params = this.convertExportParams('print');
            newIframe.src = `/beli-lepas/list/print` + '?' + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function() {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        print(data) {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/beli-lepas/print/'+data.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        deleteItem(rowData) {
            let self = this;

            Swal.fire({
                title: 'Apakah anda yakin?',
                text: "Anda tidak dapat mengembalikan data yang sudah dihapus!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, hapus!'
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    self.isLoading = true;
                    self.$Progress.start();
                    axios({
                        method: 'delete',
                        url: '/api/beli-lepas/' + rowData.id,
                    })
                    .then(function (response) {
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });
                        self.isLoading = false;
                        self.$Progress.finish();
                        self.refresh();
                    })
                    .catch(function (error) {
                        self.responseFailed(error);
                    });
                }
            })
        },
    },
}
</script>
<style>
.vuetable-slot {
    padding-bottom: 0.3rem !important;
}
</style>
